import { ScaleEnum } from "@visactor/vscale";

export const SCATTER_DEFAULT_SIZE = 10;

export const SCATTER_DEFAULT_RANGE_SIZE = [ 10, 20 ];

export const SCATTER_DEFAULT_SIZE_SCALE_TYPE = ScaleEnum.Linear;

export const SCATTER_DEFAULT_SHAPE = "circle";

export const SCATTER_DEFAULT_SHAPE_SCALE_TYPE = ScaleEnum.Ordinal;

export const SCATTER_DEFAULT_RANGE_SHAPE = [ "circle", "square", "triangle", "diamond", "star" ];
//# sourceMappingURL=scatter.js.map